import axios from 'axios';
import { useQuery } from 'react-query';
import Cookies from 'js-cookie';

export const useQueryLSBDTransactions = options => {
    return useQuery(
        ['LSBDTransactions'],
        async () => {
            const { data } = await axios.get(
                process.env.REACT_APP_SERVER + `api/Quota/Transactions/LSBD`,
                {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization:
                            'bearer ' +
                            (Cookies.get('auth-token')
                                ? Cookies.get('auth-token')
                                : '')
                    }
                }
            );
            return data;
        },
        options ? options : {}
    );
};
